import { render } from "./404.vue?vue&type=template&id=5a43446c"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=5a43446c&lang=css"
script.render = render

export default script